import React from 'react';
import './PremiumPricing.css';

const PremiumPricing = ({ price, currency = "EUR", className = "" }) => {
  return (
    <div className={`premium-pricing ${className}`}>
      <div className="price-display">
        <span className="currency">{currency}</span>
        <span className="amount">{price.toLocaleString()}</span>
      </div>
    </div>
  );
};

export default PremiumPricing;
